import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { ShellLayoutComponent } from './layout/shell-layout.component';
//import { ShellLayoutComponent } from './shell-layout.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'app',
    component: ShellLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      // AUDIT
      {
        path: 'audit',
        loadComponent: () =>
          import('./features/audit/audit-analytics.component')
            .then(m => m.AuditAnalyticsComponent),
      },

      // OVERVIEW
      {
        path: 'overview',
        loadComponent: () =>
          import('./features/overview/overview-page.component')
            .then(m => m.OverviewPageComponent),
      },

      // DASHBOARDS
      {
        path: 'dashboards',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/dashboards/dashboard-list/dashboard-list.component')
                .then(m => m.DashboardListComponent),
          },
          {
            path: 'new',
            loadComponent: () =>
              import('./features/dashboards/dashboard-detail/dashboard-detail.component')
                .then(m => m.DashboardDetailComponent),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./features/dashboards/dashboard-detail/dashboard-detail.component')
                .then(m => m.DashboardDetailComponent),
          },
        ],
      },
      // DATA SOURCES
      {
        path: 'data-sources',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/data-sources/data-source-list/data-source-list.component')
                .then(m => m.DataSourceListComponent),
          },
          {
            path: 'new',
            loadComponent: () =>
              import('./features/data-sources/data-source-detail/data-source-detail.component')
                .then(m => m.DataSourceDetailComponent),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./features/data-sources/data-source-detail/data-source-detail.component')
                .then(m => m.DataSourceDetailComponent),
          },
        ],
      },
      
      // QUERY
      {
        path: 'queries',
        loadChildren: () =>
          import('./features/query/query.module').then(m => m.QueryModule),
      },

      // SETTINGS (with children)
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.module').then(m => m.SettingsModule),
      },

      // CREATE ORGANIZATION (onboarding route; keep inside /app)
      {
        path: 'create-organization',
        loadComponent: () =>
          import('./features/org/organization-create/organization-create-page.component')
            .then(m => m.OrganizationCreatePageComponent),
      },

      // default inside app
      { path: '', pathMatch: 'full', redirectTo: 'overview' },

      // unknown inside app
      { path: '**', redirectTo: 'overview' },
    ],
  },

  // ROOT redirects
  { path: '', pathMatch: 'full', redirectTo: 'app' },
  { path: '**', redirectTo: 'app' },
];


